/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { EVENT_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import type { State } from '@zcode/state-type'
import type { Dispatch } from '../../types'
import type { PageName } from '../helpers'
import { getCommonProps } from '../helpers/getCommonProps'
import { getLeaseLengthType } from '../helpers/getLeaseLengthType'

export const mixpanelCompleteSearch =
  ({
    pageName,
    section,
    extraPayload = {},
    leaseLengthType,
  }: {
    pageName?: PageName
    section?: string
    extraPayload?: { [key: string]: any }
    leaseLengthType?: 'Short Term' | 'Long Term'
  }) =>
  (dispatch: Dispatch, getState: () => State) => {
    const state = getState()

    const payload: { [key: string]: any } = {
      ...getCommonProps({ state }),
      [PROP_NAMES.LEASE_LENGTH_TYPE]: leaseLengthType ?? getLeaseLengthType(state),
      ...extraPayload,
    }

    if (pageName) {
      payload[PROP_NAMES.PAGE_NAME] = pageName
    }

    if (section) {
      payload[PROP_NAMES.SECTION] = section
    }
    track({ event: EVENT_NAMES.COMPLETE_SEARCH, payload })
  }
